import { memo, useState } from 'react'
import { PlusIcon } from 'src/components/Icons/PlusIcon'
import { MinusIcon } from 'src/components/Icons/MinusIcon'

import type { EnvironmentalData as EnvironmentalDataType } from '../../../types/product'

type EnvironmentalDataContentProps = {
  contentOne?: EnvironmentalDataType[]
}

function mapPropertiesToObject(
  items: Array<{ propertyID: string; value: string }> = []
): Record<string, string> {
  return items.reduce<Record<string, string>>((acc, { propertyID, value }) => {
    acc[propertyID] = value

    return acc
  }, {})
}

const EnvironmentalData = ({ contentOne }: EnvironmentalDataContentProps) => {
  const [openId, setOpenId] = useState<string | null>(null)

  function toggle(id: string) {
    setOpenId((prev) => (prev === id ? null : id))
  }

  return (
    <>
      {contentOne && (
        <article
          data-testid="productDocuments"
          className="productManualAndDocs
                w-full
                flex flex-col bg-white items-left mt-8
                justify-between px-6 py-4"
        >
          <h4 className="text-[22px] leading-[118.18%] font-inter color-[#101010] pb-4 font-semibold">
            Nossa abordagem
          </h4>
          <p>
            A análise da pegada ambiental do produto nos permitiu identificar as
            etapas mais críticas do seu ciclo de vida. Com essas informações,
            nossas equipes de design desenvolveram uma solução muito mais
            sustentável.
          </p>
          <div>
            {contentOne.map((item) => {
              const additionalProperty = mapPropertiesToObject(
                item.additionalProperty
              )

              const isOpen = openId === item.identifier

              return (
                <div
                  key={item.name}
                  className="flex flex-col items-start justify-start py-1 h-full"
                >
                  <img
                    className="mt-8 mb-[13px]"
                    width={429}
                    height={222}
                    src={`https://contents.mediadecathlon.com/${additionalProperty.ACTION_IMAGE}/default.png?format=auto`}
                    alt={additionalProperty.ACTION_TYPE}
                    loading="eager"
                  />
                  <p className="text-font-size-4 font-inter color-[#101010] capitalize font-semibold">
                    {additionalProperty.ACTION_NAME}
                  </p>
                  <p className="text-font-size-4 font-inter text-tertiary capitalize">
                    {additionalProperty.LEGAL_PHRASE}
                  </p>

                  <button
                    className="flex flex-row text-primaryBlue items-center justify-center"
                    onClick={() => toggle(item.identifier)}
                  >
                    <p className="pr-2">{isOpen ? 'Ler menos' : 'Ler mais'}</p>
                    {isOpen ? (
                      <MinusIcon width={20} height={20} color="#3443ba" />
                    ) : (
                      <PlusIcon width={20} height={20} color="#3443ba" />
                    )}
                  </button>
                  {isOpen && (
                    <p className="text-font-size-3 font-inter text-tertiary border border-tertiary py-5 px-3 mt-3">
                      {additionalProperty.COMMUNICATION_TEXT}
                    </p>
                  )}
                </div>
              )
            })}
          </div>
        </article>
      )}
    </>
  )
}

export default memo(EnvironmentalData)
